import { i18n } from "../../globalization/i18n.js";
import { Editor } from "./Editor.js";

export class ComboBox extends Editor {

    constructor(parent, options = {}) {

        super(parent, options);

        const {
            valueContainsItem = false,
            items = [],
            itemValueProp = 'value',
            itemLabelProp = 'label',
            itemDisabledProp = 'disabled',
            emptyOptionValue = null,
            emptyOptionLabel = i18n.t('control.combobox.empty_value.select'),
            onGetOptionValue = null,
            onGetOptionLabel = null,
            onGetOptionDisabled = null,
        } = options;

        this.valueContainsItem = valueContainsItem;
        this.items = items;
        this.itemValueProp = itemValueProp;
        this.itemLabelProp = itemLabelProp;
        this.itemDisabledProp = itemDisabledProp;
        this.emptyOptionValue = emptyOptionValue;
        this.emptyOptionLabel = emptyOptionLabel;
        this.onGetOptionValue = onGetOptionValue;
        this.onGetOptionLabel = onGetOptionLabel;
        this.onGetOptionDisabled = onGetOptionDisabled;

    };

    getDataValueProp() {

        return (typeof this.dataValueProp === 'function') ? this.dataValueProp.call(this) : this.dataValueProp;

    };

    getDataValue(value) {

        if (this.onGetDataValue && (typeof this.onGetDataValue == 'function'))
            return this.onGetDataValue.call(this, value);
        if (!value)
            return null;
        return value[this.dataValueProp];

    };

    getItems() {

        return (typeof this.items === 'function') ? this.items.call(this) : this.items;

    };

    getOptionValue(item) {

        if (this.onGetOptionValue && (typeof this.onGetOptionValue == 'function'))
            return this.onGetOptionValue.call(this, item);
        if (!item)
            return this.emptyOptionValue;
        return item[this.itemValueProp];

    };

    getOptionLabel(item) {
        if (this.onGetOptionLabel && (typeof this.onGetOptionLabel == 'function'))
            return this.onGetOptionLabel.call(this, item);
        if (!item)
            return this.emptyOptionLabel;
        return item[this.itemLabelProp];

    };

    getOptionDisabled(item) {

        if (this.onGetOptionDisabled && (typeof this.onGetOptionDisabled == 'function'))
            return this.onGetOptionDisabled.call(this, item);
        if (!item)
            return false;
        if (Object.hasOwn(item, this.itemDisabledProp))
            return item[this.itemDisabledProp];
        return false;

    };

    _render(r, vm) {

        if (!this.isVisible())
            return null;

        const renderer = r;

        var that = this,
            value = this.valueContainsItem ? this.getOptionValue(this.getValue()) : this.getValue(),
            options = (this.getItems() || []).map(function (item) {
                var optValue = that.getOptionValue(item) || null,
                    optLabel = that.getOptionLabel(item) || '?',
                    optDisabled = that.getOptionDisabled(item) || false;
                return {
                    value: optValue,
                    label: optLabel,
                    disabled: optDisabled,
                    data: item
                };
            }),
            style = this.getCss(),
            props = {
                id: this.getId(),
                disabled: (this.isDisabled() || this.isReadOnly()) ? 'disabled' : null,
                onchange: onValueChange
            },
            params = {
                css: style,
                props,
                items: options,
                emptyValue: this.emptyOptionValue,
                emptyLabel: this.emptyOptionLabel,
            };

        return renderer.comboBox(value, params);

        function onValueChange(e, node) {
            e.preventDefault();
            var value = e.target.value,
                data = options.find((option) => String(option.value ?? '') === String(value ?? ''))?.data ?? null;
            //that.changeValue(value);
            that.changeValue(that.valueContainsItem ? data : value);
        };

    };

}
